const START = 'START'
const STOP = 'STOP'

const initialState = {
    isLoading: true
}

const loaderReducer = (state = initialState, {type}) => {
    switch (type) {
        case START:
            return {
                ...state,
                isLoading: true
            }

        case STOP:
            return {
                ...state,
                isLoading: false
            }

        default:
            return state
    }
}

export default loaderReducer
